import React from 'react';
import { PageSection, ListFieldSection, FieldSet, Grid, GridFieldSection } from '../Layout';
import { TextInput, Field, NumericInput, TextAreaInput, Label, TextOutput, Message, EmailInput } from '../Core';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../Data/ReduxViewModels/Admin';
import { Link } from 'Components/Core';

const UsageTrackerSection = () => {
  return (
    <ListFieldSection single heading="Tracking Interval">
      <FieldSet>
        <Field label="Within Business Hours (hrs)" input={<TextOutput />} value={1} />
        <Field
          label="Outside of Business Hours (hrs)"
          input={<NumericInput step="1" />}
          name={`syncModel.NonBusinessHoursTrackingPeriod`}
          format={{ nearest: 1 }}
        />
      </FieldSet>
    </ListFieldSection>
  );
};

const LoggingSection = () => {
  return (
    <ListFieldSection single>
      <Message warning>
        Changes to logging settings will require a <Link to="/admin/restart">QESTNet restart.</Link>
      </Message>
      <FieldSet>
        <Field label="Log File Path" input={<TextInput />} name={`syncModel.LogFilePath`} />
        <Field label="Archive File Path" input={<TextInput />} name={`syncModel.ArchiveFilePath`} />
      </FieldSet>
    </ListFieldSection>
  );
};

const IntegratorSection = () => {
  return (
    <ListFieldSection single heading="Schedule">
      <FieldSet>
        <Field
          label="Start Time (hh:mm:ss)"
          input={<TextInput />}
          placeholder="hh:mm:ss"
          messages={[{ message: 'The time when the first email will be generated and sent', severity: 'info' }]}
          name={`syncModel.IntegratorStartTime`}
        />
        <Field
          label="Recurrence (dd.hh:mm:ss)"
          input={<TextInput />}
          placeholder="dd.hh:mm:ss"
          name={`syncModel.IntegratorTransferInterval`}
          messages={[{ message: 'How often the license summary email will be sent', severity: 'info' }]}
        />
      </FieldSet>
    </ListFieldSection>
  );
};

const EmailSection = () => {
  const recipients = useSelector((state) => state.admin.syncModel.Recipients);
  const recipientFields = () => {
    if (!recipients) return [];

    return recipients.map((_, i) => [<Field input={<EmailInput />} name={`syncModel.Recipients[${i}]`} />]);
  };

  const dispatch = useDispatch();
  const addRecipient = () => {
    dispatch(actions.setValue({ name: 'syncModel.Recipients', value: [...recipients, ''], sync: true }));
  };
  const removeRecipient = (index) => {
    dispatch(
      actions.setValue({
        name: 'syncModel.Recipients',
        value: recipients.filter((_, i) => i !== index),
        sync: true,
      })
    );
  };

  return (
    <ListFieldSection single heading="Summary Email">
      <FieldSet>
        <Field label="From Address" input={<EmailInput />} name={`syncModel.FromAddress`} />
        <Field label="Subject" input={<TextInput />} name={`syncModel.Subject`} />
        <Field label="Body" input={<TextAreaInput />} name={`syncModel.Body`} />
      </FieldSet>
      <Label>{'Recipients'}</Label>
      <GridFieldSection>
        <Grid data={recipientFields()} colWidths={300} onCreateRow={addRecipient} onRemoveRow={removeRecipient} />
      </GridFieldSection>
    </ListFieldSection>
  );
};

const LicenseUsageSettingsAdmin = () => (
  <>
    <PageSection heading="License Summary Email Settings">
      <Message warning>
        Changes to license summary email settings will require a <Link to="/admin/restart">QESTNet restart.</Link>
      </Message>
      <EmailSection />
      <IntegratorSection />
    </PageSection>
    <PageSection heading="License Logging Settings">
      <LoggingSection />
    </PageSection>
    <PageSection heading="License Usage Tracker Settings">
      <UsageTrackerSection />
    </PageSection>
  </>
);

export default LicenseUsageSettingsAdmin;
export { LicenseUsageSettingsAdmin };
